// Prevents eslint from complaining that "google is not defined"
/*global google */
import React, {PropTypes} from 'react';
import mapStyle from '../styles/map-style.js';
import SelectionShow from '../containers/SelectionShow';

class Map extends React.Component {

  constructor () {
    super();
    this.initMap = this.initMap.bind(this);
    this.displayAreasOnMap = this.displayAreasOnMap.bind(this);
    this.getRecommendationColor = this.getRecommendationColor.bind(this);
    this.refreshAllCountryColors = this.refreshAllCountryColors.bind(this);
    this.highlightArea = this.highlightArea.bind(this);
    this.drawMarkers = this.drawMarkers.bind(this);

    // Catch the case where the map load has failed because of overquota
    // move this to the Home
    this.map_load_success = (typeof google !== 'undefined');
  }

  componentDidMount () {
    if (this.map_load_success){
      this.initMap();
    }
  }

  componentDidUpdate () {
    if (this.map_load_success){
      this.refreshAllCountryColors();
      this.highlightArea();
      this.highlightSelection();
      this.drawMarkers();
    }
  }

  /*
  * Refreshes colors of countries
  */
  refreshAllCountryColors () {
    let currentMonth = this.props.selection.currentMonth;
    let allAreas = this.props.data;
    // Because the this inside each has a different scope
    let self = this;

    // Go through all countries
    $.each(allAreas, function(key) {
      let color = self.getRecommendationColor(key, currentMonth);
      // Go through every feature already on the map
      window.map.data.forEach(function(feature){
        if(key == feature['l'].countryCode) {
          window.map.data.overrideStyle(feature, {fillColor: color});
        }
      });
    });
  }

  // Draw markers
  drawMarkers () {

    if(!window.markers){
      window.markers = [];
    }

    let markers = window.markers;
    let selection = this.props.selection.area_ids;
    let allAreas = this.props.data;

    // Empty shape for click-through icons
    let shape = {
      coords: [],
      type: 'poly'
    };

    let image;
    let icon;
    let options;

    let i=0;
    let newMarkers = [];

    // Redraw all markers on top of the existing ones
    selection.forEach(function(areaId){

      let area = allAreas[areaId];
      image = './' + (i + 1) + '.png';
      icon = {
        url: image,
        origin: new google.maps.Point(0,0),
        anchor: new google.maps.Point(11,11),
        scaledSize: new google.maps.Size(23,23)
      };
      options = {
        position: {lat: area['ll'][0], lng: area['ll'][1]},
        map: window.map,
        icon: icon,
        shape: shape
      };

      // Draw all markers
      let marker = new google.maps.Marker(options);
      // markers[areaId] = marker;
      newMarkers[areaId] = marker;

      i++;
    });

    // Delete all old markers
    for (let areaId in markers) {
      // timeout because it takes less time to delete than create and
      // we would get a flickering effect without this
      setTimeout(function(){  markers[areaId].setMap(null); }, 50);
    }

    window.markers = newMarkers;
  }

  // Draw a black outline on the selection
  highlightSelection () {
    let layer = window.selectionLayer;
    let selection = this.props.selection.area_ids;
    let allAreas = this.props.data;
    let alreadyDrawn = [];
    let areaId;

    // Delete layers that should not be highlighted anymore
    layer.forEach(function(feature){
      areaId = feature.getProperty('area_id');

      // If the current feature is not in the selection list
      if(selection.indexOf(areaId) == -1){
        layer.remove(feature);
      }
    });

    // Build the list of which remaining areas are already drawn
    layer.forEach(function(feature){
      areaId = feature.getProperty('area_id');
      alreadyDrawn.push(areaId);
    });

    // Define if a new outline needs to be drawn
    selection.forEach(function(areaId){

      // If the current areaId not already drawn
      if (alreadyDrawn.indexOf(areaId) == -1){

        // Draw it
        // add the geojson to the layer
        layer.addGeoJson({
          'type': 'Feature',
          'properties': {
            'type': 'selection',
            'area_id': areaId
          },
          'geometry': allAreas[areaId]['geometry']
        });

        // Add a white outline bellow it
        layer.addGeoJson({
          'type': 'Feature',
          'properties': {
            'type': 'selection_bis',
            'area_id': areaId
          },
          'geometry': allAreas[areaId]['geometry']
        });
      }
    });

    // Set styles for each feature
    //layer.forEach(function(feature){

      layer.setStyle(function(feature){
        let type = feature.getProperty('type');

        if(type == 'selection'){
          return {
            fillColor: '#fff',
            fillOpacity: 0,
            strokeWeight: 1,
            strokeOpacity: 0.6,
            strokeColor: '#000',
            clickable: false,
            zIndex: 4
          };
        }
        else{
          return {
            fillColor: '#fff',
            fillOpacity: 0,
            strokeWeight: 3,
            strokeOpacity: 0.1,
            strokeColor: '#fff',
            clickable: false,
            zIndex: 3
          };
        }
      });
    //});
  }

  // Draw a black outline on the area that was just clicked
  highlightArea () {
    let allAreas = this.props.data;
    let currentArea = this.props.selection.infobox_area_id;
    let areaIsAlreadyDrawn = false;

    // Delete layers that should not be highlighted anymore
    window.highlightLayer.forEach(function(feature){
      if(feature.getProperty('area_id') != currentArea){
        window.highlightLayer.remove(feature);
      }
    });

    // Define if something new needs to be drawn
    window.highlightLayer.forEach(function(feature){
      if (feature.getProperty('area_id') == currentArea){
        areaIsAlreadyDrawn = true;
      }
    });

    if (currentArea && !areaIsAlreadyDrawn) {
      let currentGeometry = allAreas[currentArea]['geometry'];

      // add the geojson to the layer
      window.highlightLayer.addGeoJson({
        'type': 'Feature',
        'properties': {
          'type': 'highlight',
          'area_id': currentArea
        },
        'geometry': currentGeometry
      });

      // Add a white outline bellow it
      window.highlightLayer.addGeoJson({
        'type': 'Feature',
        'properties': {
          'type': 'highlight_bis',
          'area_id': currentArea
        },
        'geometry': currentGeometry
      });

      // set the style of the layer
      window.highlightLayer.setStyle(function(feature){
        let type = feature.getProperty('type');

        if(type == 'highlight'){
          return {
            fillColor: '#fff',
            fillOpacity: 0,
            strokeWeight: 1,
            strokeOpacity: 0.6,
            strokeColor: '#000',
            clickable: false,
            zIndex: 4
          };
        }
        else{
          return {
            fillColor: '#fff',
            fillOpacity: 0,
            strokeWeight: 3,
            strokeOpacity: 0.1,
            strokeColor: '#fff',
            clickable: false,
            zIndex: 3
          };
        }
      });
    }
  }

  /*
  * Returns a color code
  *
  * @param {String} countryCode
  * @param {String} monthNumber
  * @return {String}
  */
  getRecommendationColor (countryCode, monthNumber) {
    let colors = {'no': '#c4c4c4', 'yes': 'green', 'average': '#67c68f'};
    let recommendation = this.props.data[countryCode]['recommended'][monthNumber-1]['color'];
    return colors[recommendation];
  }

  /*
  * Display countries on the map
  */
  displayAreasOnMap () {
    let allAreas = this.props.data;
    let currentMonth = this.props.selection.currentMonth;
    let self = this;

    // Construct the countries outlines
    $.each(allAreas, function(key, area) {
      let feature;
      if(area['type'] == 'c') {
        feature = {
          'type': 'Feature',
          'properties': {
            'type': 'outline',
            'countryCode': '',
            'color': ''
          },
          'geometry': area['geometry']
        };
      }
      window.map.data.addGeoJson(feature);
    });

    // Construct the countries backgrounds by duplicating countries!
    $.each(allAreas, function(key, area) {
      let currentColor = self.getRecommendationColor(key, currentMonth);

      // instead, ask: 'if the country has zero sectors'
      // we use the country geometry to build sectors
      // This is just to optimize
      // We tag all these with sectorId = 'c_' + country.id ?
      if(area['render_as_sector']) {
        window.map.data.addGeoJson({
          'type': 'Feature',
          'properties': {
            'type': area['type'],
            'countryCode': key,
            'country_id': area['country_id'],
            'color': currentColor
          },
          'geometry': area['geometry']
        });
      }
    });

    // Color each feature
    // Go through our data layer and set a style matching the properties.color of each feature
    window.map.data.setStyle(function(feature) {

      let color = feature.getProperty('color');
      let type = feature.getProperty('type');
      // Destinations get a white outline
      if(type == 'c' || type == 's'){
        return {
          fillColor: color,
          fillOpacity: 0.55,
          strokeWeight: 1,
          strokeOpacity: 0.1,
          strokeColor: '#fff',
          zIndex: 1
        };
      }
      // Countries get a dark outline
      if(type == 'outline') {
        return {
          fillColor: '#fff',
          fillOpacity: 0,
          strokeWeight: 1,
          strokeOpacity: 0.15,
          strokeColor: '#000',
          clickable: false,
          zIndex: 2
        };
      }
    });

    // Mouseover
    window.map.data.addListener('mouseover', function(event) {
      window.map.data.overrideStyle(event.feature, {
        fillOpacity: 0.45,
        strokeOpacity: 0.2
      });
      // http://googlemapapitutorial.com/customizedtooltip.jsps
      // http://gis.stackexchange.com/questions/15540/how-to-display-mouse-position-as-tooltip-in-openlayers
      // http://stackoverflow.com/questions/6558160/get-position-of-mouse-cursor-on-mouseover-of-google-maps-v3-api-marker
      // console.log(event.feature.getProperty('countryCode'));
    });

    // Mouseout
    window.map.data.addListener('mouseout', function(event) {
      window.map.data.overrideStyle(event.feature, {
        fillOpacity: 0.55,
        strokeOpacity: 0.1
      });
    });

    // Click
    window.map.data.addListener('click', function(event) {
      let areaId = event.feature.getProperty('countryCode');
      this.props.selectionActions.displayInfobox(areaId);

      // Stop the autoplay if needed
      if(this.props.autoplay.autoplay){
        this.props.autoplayActions.autoplayStop();
      }
    }.bind(this));
  }

  initMap () {
    // Define the center of the map
    let center;
    if($(window).height() > 600) {
      // Large screen, Algeria
      center = new google.maps.LatLng(30, 0);
    }
    else {
      // Small screen: France
      center = new google.maps.LatLng(45, 0);
    }

    let mapOptions = {
      minZoom: 1,
      maxZoom: 6,
      zoom: 3,
      center: center,
      mapTypeId: google.maps.MapTypeId.ROADMAP,
      styles: mapStyle,
      mapTypeControlOptions: {
        mapTypeIds: []
      },
      streetViewControl: false,
      zoomControl: true,
      zoomControlOptions: {
        style: google.maps.ZoomControlStyle.LARGE,
        position: google.maps.ControlPosition.LEFT_BOTTOM
      },
      fullscreenControl: false,
      keyboardShortcuts: false
    };

    window.map = new google.maps.Map(document.getElementById('map_canvas'), mapOptions);

    this.displayAreasOnMap();

    // New data layer for holding the highlight of the selected area
    window.highlightLayer = {};
    window.highlightLayer = new google.maps.Data();
    window.highlightLayer.setMap(window.map);

    // New data layer for holding the highlight of the selection
    window.selectionLayer = {};
    window.selectionLayer = new google.maps.Data();
    window.selectionLayer.setMap(window.map);

    // Unselect when clicking anywhere in the sea
    // google.maps.event.addListener(map, "click", function(event) {
    //  this.props.selectionActions.unselectArea();
    // }.bind(this));
  }



  render() {
    //Promo display
    let promo = '';
    if (this.props.selection.promoDisplayed) {
      promo = (
        <div className="promo">
          <p className="title">
            Flight prices <span className="badge new">New</span>
          </p>
          <p className="legend">
            Click countries to see the cheapest flights through the year.
          </p>
        </div>
      )
    }

    return (
      <div className="map-container">
        <div id="map_canvas" />
        <div className="legend-container">
          <div className="legend-background">
            <div className="legend-item">
              <span className="legend-recommended" /> Best weather
            </div>
            <div className="legend-item">
              <span className="legend-average" /> Alright weather
            </div>
            <div className="legend-item">
              <span className="legend-not-recommended" />Cold / Hot / Rainy
            </div>
          </div>
          <SelectionShow />
          {promo}
        </div>
      </div>
    );
  }
}

Map.propTypes = {
  data: PropTypes.object.isRequired,
  selection: PropTypes.object.isRequired,
  selectionActions: PropTypes.object.isRequired,
  autoplay: PropTypes.object.isRequired,
  autoplayActions: PropTypes.object.isRequired
};

export default Map;



/** WEBPACK FOOTER **
 ** ./src/components/Map.js
 **/